import { ContentSlider } from '@eventbrite/eds-content-slider';
import React, { useState } from 'react';
import { AgendaWrapper, TabItem, TabsArea } from './Agenda.styles';
import { SlotPreview } from './SlotPreview';
import { AgendaWidget } from './types';

interface Props {
    agenda: AgendaWidget;
}

export const Agenda: React.FC<Props> = ({ agenda }) => {
    const tabs = agenda?.tabs || [];
    const shouldDisplayTabs = tabs.length > 1;
    const [currentTab, changeCurrentTab] = useState(0);
    const [slots, changeSlots] = useState(tabs?.[currentTab]?.slots || []);

    const switchToTab = (index: number) => {
        changeCurrentTab(index);
        changeSlots(agenda?.tabs[index].slots);
    };

    return slots.length ? (
        <AgendaWrapper data-testid="agenda-component">
            {shouldDisplayTabs && (
                <ContentSlider>
                    <TabsArea>
                        {tabs.map((tab, index) => (
                            <TabItem
                                key={index}
                                active={index === currentTab}
                                onClick={() => switchToTab(index)}
                            >
                                {tab.name}
                            </TabItem>
                        ))}
                    </TabsArea>
                </ContentSlider>
            )}
            {slots.map((slot, slotIndex) => (
                <SlotPreview
                    key={slotIndex}
                    slot={slot}
                    slotIndex={slotIndex}
                />
            ))}
        </AgendaWrapper>
    ) : null;
};
